/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Row_AcInputs */

const en_cmp_row_ac = /** @type {(inputs: Cmp_Row_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptance criteria per task`)
};

const id_cmp_row_ac = /** @type {(inputs: Cmp_Row_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kriteria penerimaan per task`)
};

/**
* | output |
* | --- |
* | "Acceptance criteria per task" |
*
* @param {Cmp_Row_AcInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_row_ac = /** @type {((inputs?: Cmp_Row_AcInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Row_AcInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_row_ac(inputs)
	return en_cmp_row_ac(inputs)
});